import "./contactLinks.css";
import SocialMediaLinks from "./SocialMediaLinks";

const ContactList = () => {
  return (
    <>
      <SocialMediaLinks />
      <div className="email-container ">
        <a
          className="email-container_email font-family-class"
          href="mailto:zabihullahazadzoi848249@gmail.com"
        >
          zabihullahazadzoi848249@gmail.com
        </a>
      </div>
    </>
  );
};

export default ContactList;
